// extracted by mini-css-extract-plugin
module.exports = {"darkLightModeToggle":"DarkLightModeToggle_darkLightModeToggle__4_G16"};